<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
          <div class="mr-auto mb-3">
            <div class="text-dark font-weight-bold font-size-24">
              <span class="mr-3">Gestão de Arquivos CNAB</span>
              <span
                class="align-middle text-primary text-uppercase font-size-12 badge badge-light"
                >Arquivo de Remessa</span
              >
            </div>
            <div>
              Interface Administrativa para gestão da liquidação via arquivos de
              remessa e retorno
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <b-container fluid>
        <template v-if="loading">
          <div class="d-flex justify-content-center bd-highlight mb-3">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="mb-5">
            <b-tabs justifiedx>
              <b-tab active>
                <div slot="title">
                  <div class="mb-xl-0 mb-3" :class="$style.item">
                    <span :class="$style.icon">
                      <i class="fe fe-search" />
                    </span>
                    <div :class="$style.desc">
                      <span :class="$style.title">Previsão</span>
                      <p>Quanto eu tenho para liquidar</p>
                    </div>
                    <div :class="$style.line" class="bg-inverse" />
                  </div>
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <prevision />
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <div slot="title">
                  <div class="mb-xl-0 mb-3" :class="$style.item">
                    <span :class="$style.icon">
                      <i class="fe fe-download" />
                    </span>
                    <div :class="$style.desc">
                      <span :class="$style.title">Geração de Arquivo</span>
                      <p>Crie e integre a remessa bancária</p>
                    </div>
                    <div :class="$style.line" class="bg-inverse" />
                  </div>
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    2w131231
                  </div>
                </div>
              </b-tab>
              <b-tab title="Link">
                <div slot="title">
                  <div class="mb-xl-0 mb-3" :class="$style.item">
                    <span :class="$style.icon">
                      <i class="fe fe-home" />
                    </span>
                    <div :class="$style.desc">
                      <span :class="$style.title">Previsão</span>
                      <p>Quanto eu tenho para liquidar</p>
                    </div>
                    <div :class="$style.line" class="bg-inverse" />
                  </div>
                </div>
                <div class="p-4 mt-4 border rounded">Tab 3 Contents</div>
              </b-tab>
              <b-tab disabled>
                <div slot="title">
                  <div class="mb-xl-0 mb-3" :class="$style.item">
                    <span :class="$style.icon">
                      <i class="fe fe-home" />
                    </span>
                    <div :class="$style.desc">
                      <span :class="$style.title">Previsão</span>
                      <p>Quanto eu tenho para liquidar</p>
                    </div>
                    <div :class="$style.line" class="bg-inverse" />
                  </div>
                </div>
                <div class="p-4 mt-4 border rounded">Tab 4 Contents</div>
              </b-tab>
            </b-tabs>
          </div>
        </template>
      </b-container>
    </div>
  </div>
</template>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<script>
import { get as _get, debounce as _debounce } from "lodash";
import moment from "moment";
import Prevision from "./widgets/prevision.vue";
export default {
  name: "Cnab",
  components: {
    Prevision,
  },
  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 25,
        months: "1",
        idCostCenter: null,
        idSaleChannel: null,
        idMerchant: null,
      },
      itens: [],
      costCenters: [],
      saleChannels: [],
      displayItens: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      filter: null,
      merchants: [],
      dipositivoEditar: null,
    };
  },
  methods: {
    moment,
  },
  computed: {
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {},
};
</script>